// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__jcD6i","contactHead":"styles_contactHead__BwLW2"};